/**
 * pilot.tsx
 */
import Container from '@components/atoms/container/pilotContainer';
import Footer from '@components/sections/pilot/pilotFooter';
import Header from '@components/sections/pilot/pilotHeader';
import Logo from '@components/elements/pilot/pilotLogo';
import Mask from '@components/elements/pilot/pilotMask';
import NextEpisode from '@components/elements/nextEpisode/nextEpisode';
import usePilotSelector from './usePilotSelector';
import { PilotType, PilotProps as Props } from '@shared/types/props/pilot';

/**
 * Displays the pilot mask, logo and content based on the channel and vod props.
 */
export default function Pilot(parentProps: Props) {
  const { props } = usePilotSelector(parentProps);
  return (
    <>
      {parentProps.type === PilotType.VOD ? <NextEpisode /> : null}
      <Logo {...props.logo} />
      <Container {...props.container}>
        <Mask />
        <Header {...props.header} />
        <Footer {...props.footer} />
      </Container>
    </>
  );
}
